import { createFileRoute } from '@tanstack/react-router'
import VehiclesTable from '../../../../../components/VehiclesTable/VehiclesTable'
import React from 'react'
import { generateRandomString } from '../../../../utils'
import { getAllData } from '../../../../../utils/data'
import { Vehicle } from 'server'
import useRouteLog from '../../../../hooks/useRouteLog'
import { adminAuth } from '../../../../hooks/beforeLoad/adminAuth'
import LoadingScreen from '../../../../LoadingScreen/LoadingScreen'

export const Route = createFileRoute('/admin/_layout/devices/')({
  beforeLoad: adminAuth,
  component: RouteComponent,
  pendingComponent: () => <LoadingScreen />,
  loader: async ({ context }) => {
    const rsg = generateRandomString()
    const label = `/admin/_layout/vehicles/index.tsx loader: ${rsg}`
    console.time(label)

    const { client, queryClient, authUser } = context

    const allowedAgencies = authUser?.allowed_agencies
      .split(',')
      .map((id: string) => parseInt(id))

    const assettrakTimeFilter =
      window.localStorage.getItem('assettrak_time_filter') || '1_day' // default to 1 day

    const vehicleVehicleLocationsQuery = {
      allowed_agencies: allowedAgencies,
      timeframe: assettrakTimeFilter,
    }

    const vehicleVehicleLocations = await queryClient.ensureQueryData({
      queryKey: [
        'vehicle-vehicle-location',
        'find',
        vehicleVehicleLocationsQuery,
      ],
      queryFn: () =>
        client.service('vehicle-vehicle-location').find({
          query: vehicleVehicleLocationsQuery,
        }),
      gcTime: 0,
      staleTime: 0,
    })

    /* Agencies */
    const agencyIds = [
      ...new Set(
        vehicleVehicleLocations.vehicles.map(
          (vehicle: Vehicle) => vehicle.agency_id,
        ),
      ),
    ]
    const agenciesQuery = {
      id: {
        $in: agencyIds,
      },
    }
    const agencies = await queryClient.ensureQueryData({
      queryKey: ['agencies', 'find', agenciesQuery],
      queryFn: () => getAllData(client, 'agencies', agenciesQuery),
    })

    /* Vehicle Types */
    const vehicleTypeQuery = {}
    const vehicleTypes = await queryClient.ensureQueryData({
      queryKey: ['vehicle-type', 'find', vehicleTypeQuery],
      queryFn: () => getAllData(client, 'vehicle-type', vehicleTypeQuery),
    })

    /* Vehicle Categories */
    const vehicleCategoryQuery = {}
    const vehicleCategories = await queryClient.ensureQueryData({
      queryKey: ['vehicle-category', 'find', vehicleCategoryQuery],
      queryFn: () =>
        getAllData(client, 'vehicle-category', vehicleCategoryQuery),
    })

    /* ADSB */
    const adsbQuery = {
      adsb_position_updates: 1,
    }
    const adsb = await queryClient.ensureQueryData({
      queryKey: ['unit-location', 'find', adsbQuery],
      queryFn: () => getAllData(client, 'unit-location', adsbQuery),
    })

    console.timeEnd(label)

    return {
      vehicles: vehicleVehicleLocations.vehicles,
      vehicleLocations: vehicleVehicleLocations.vehicle_locations,
      agencies,
      vehicleTypes,
      adsb,
      vehicleCategories,
    }
  },
})

function RouteComponent() {
  useRouteLog('/admin/_layout/vehicles/')
  return <VehiclesTable />
}
